export const ENDPOINTS = {
  AUTH: "auth",
  ADD_USER: "add_user",
  ADD_CONFIG: "add_config",
  CHANGE_MAIN: "change_main",
  CHANGE_USAGE: "change_usage",
  CHANGE_USER_MTI: "change_user_mti",
  CHANGE_USER_PASS: "change_user_pass",
  CHANGE_USER_STATUS: "change_user_status",
  GET_DATA: "get_all",
  GET_VACS: "get_vacs",
  GET_USERS: "get_users",
  GET_APPLIES: "get_to_send",
  GET_CONFIGS: "get_configs",
  GET_RESPONDS: "get_responds",
  GET_STATISTIC: "get_statistic",
  GET_CLIENT_INFO: "get_client_info",
  GET_AVITO_REPORTS: "get_avito_reports",
  MAKE_SENT: "make_sent",
  MARK_SHOWED: `mark_showed`,
  MARK_REMOVED: `mark_removed`,
  RENAME_USER: "rename_user",
  UPD_APPLICANT: "upd_applicant",
  UPD_RESP_INFO: "upd_resp_info",
};
